import { render, staticRenderFns } from "./loading-indicator.vue?vue&type=template&id=e887da72&"
import script from "./loading-indicator.vue?vue&type=script&lang=ts&"
export * from "./loading-indicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e887da72')) {
      api.createRecord('e887da72', component.options)
    } else {
      api.reload('e887da72', component.options)
    }
    module.hot.accept("./loading-indicator.vue?vue&type=template&id=e887da72&", function () {
      api.rerender('e887da72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/loading-indicator.vue"
export default component.exports